import { BroadcastWSActions, BroadcastWSMessages } from 'common/constants';
import { SendReactionParams } from 'domain/Broadcast';
import { MeetingWSParams } from 'store/features/event/types/meeting.types';
import { createMeetingWSAsyncAction, createMeetingWSMessage } from 'store/utils';

import { ReceivedReaction } from './types';

export const reactionReceived_WS = createMeetingWSMessage<ReceivedReaction>(BroadcastWSMessages.ReactionReceived);

export const sendBroadcastReaction_WS = createMeetingWSAsyncAction<MeetingWSParams<SendReactionParams>>(
  BroadcastWSActions.SendReaction
);
